import React from 'react';
import CanvasContextMenu from './CanvasContextMenu';
import BridgeDeleteMenu from './BridgeDeleteMenu';
import AddMissionAroundMilestoneModal from '../TaskNode/components/AddMissionAroundMilestoneModal';

/**
 * Menus that float over the board: right-click, bridge-on-delete, and
 * the before/after milestone placement choice.
 */
const FlowchartMenus = ({
  canvasMenuRef,
  onAddMission,
  onAddDecision,
  onAddWait,
  onCreateCampaign,
  onPaste,
  onCloseContextMenu,
  bridgePrompt,
  onBridge,
  onBreak,
  onCancelBridge,
  pendingMilestonePlacement,
  onCancelMilestone,
  onChooseMilestone,
}) => (
  <>
    <CanvasContextMenu
      ref={canvasMenuRef}
      onAddMission={onAddMission}
      onAddDecision={onAddDecision}
      onAddWait={onAddWait}
      onCreateCampaign={onCreateCampaign}
      onPaste={onPaste}
      onClose={onCloseContextMenu}
    />

    {bridgePrompt && (
      <BridgeDeleteMenu
        position={bridgePrompt.position}
        taskCount={bridgePrompt.taskIds.length}
        upstreamCount={bridgePrompt.info.upstreamCount}
        downstreamCount={bridgePrompt.info.downstreamCount}
        onBridge={onBridge}
        onBreak={onBreak}
        onCancel={onCancelBridge}
      />
    )}

    <AddMissionAroundMilestoneModal
      isOpen={!!pendingMilestonePlacement}
      milestoneName={pendingMilestonePlacement?.feed?.milestone?.name}
      nodeType={pendingMilestonePlacement?.nodeType}
      onCancel={onCancelMilestone}
      onChoose={onChooseMilestone}
    />
  </>
);

export default FlowchartMenus;
